import { MobileAppBanner } from '@healthhub/react-ui';

import { useGetMobileAppBannerQuery } from '@shared/services/sitecore';

import PopularServices from './PopularServices';

const PreLoginDashboard = () => {
  const { data, isLoading } = useGetMobileAppBannerQuery();

  return (
    <>
      <MobileAppBanner data={data} isLoading={isLoading} />
      <PopularServices />
    </>
  );
};

export default PreLoginDashboard;
